export default {
  CLOSE_MENU: "languageSwitcher/CLOSE_MENU",
  TOGGLE_DROP_DOWN: "languageSwitcher/TOGGLE_DROP_DOWN",
  SET_DATA: "languageSwitcher/SET_DATA"
};
